export const PERFORMER_CHECK_IN_STATUS = {
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING',
    FAILED: 'FAILED',
    WINDOW_NOT_OPEN: 'WINDOW_NOT_OPEN',
    NOT_APPLICABLE: 'NOT_APPLICABLE'
}